import React, { Component } from 'react';
import {
View,
  Text,
  ScrollView,TouchableHighlight,FlatList,Dimensions,Animated,Image, Easing,Platform
} from 'react-native';
import {StyleContext} from '../styleC';

import firebase from './firebase';
import { getDatabase, ref, set, update, remove, get, onValue, child, orderByChild, orderByValue} from "firebase/database";
import strings from '../strings';
import info from '../info';
import SortableList from './SortableList';
import MavButton from './mavButton';
import MavAlert from './mavAlert';
import Modal from './modal';
import MavNavigationMinimize from './mavNavigationMinimize';
import languageList from '../languageList';
import MavInfoBubble from './mavInfoBubble';
import example from '../example';
const timer = require('react-native-timer');
import TextPresentation from './textPresentation';
import MavMiniButton from './mavMiniButton';






export default class help extends Component {
  constructor(props) {
    super(props);
    var params=(this.props.route!=undefined)?this.props.route.params:this.props.params; 

    if(Platform.OS!="web"){
        this.props.navigation.setOptions({ title: (params!=undefined)?( (params.customerReviews===true)? strings.customerReviews: ((params.smsPrefill===true)?strings.smsPrefill:strings.help) ):strings.help, })
    }  

    var smsPrefillListBase=["validate", "validateT"] 
    if(info.stripePublicKey!=undefined) {
      smsPrefillListBase.push("validateP"); 
      smsPrefillListBase.push("validatePT"); 
    }
    smsPrefillListBase.push("cancelRace");
    smsPrefillListBase.push("userRequestAnnulation"); 
    smsPrefillListBase.push("imcoming");
    smsPrefillListBase.push("imhere");
    


    this.state={
      params:params,
      selectedElement:"fr",
      addHelpSelected:false,
      removeInProgress:false,
      disableNavigation:(params!=undefined && params.disableNavigation==true && Platform.OS=="web")?true:false,
      googleMyBusinessText:(params!=undefined && params.googleMyBusinessText!=undefined)?params.googleMyBusinessText:{fr:""}, 
      oldGoogleMyBusinessText:(params!=undefined && params.googleMyBusinessText!=undefined)?JSON.parse(JSON.stringify(params.googleMyBusinessText)):{fr:""}, 
      faq:{},
      faqSave:{}, 
      driver:(params!=undefined && params.driver===true)?true:false,
      customerReviews:(params!=undefined && params.customerReviews===true)?true:false,
      smsPrefill:(params!=undefined && params.smsPrefill===true)?true:false,
      activateGoogleMyBusiness:(params!=undefined && params.activateGoogleMyBusiness===true)?true:false,
      activateComment:(params!=undefined && params.activateComment===true)?true:false,
      activateDriverNotation:(params!=undefined && params.activateDriverNotation===true)?true:false,
      activateCustomerNotation:(params!=undefined && params.activateCustomerNotation===true)?true:false,
      smsPrefillList:{},
      smsPrefillListBase:smsPrefillListBase,
    }
  }
  
   componentDidMount(){

    if(this.state.smsPrefill==true){

        get(child(ref(getDatabase(firebase)), "/prefill/sms")).then(snapshot => { 
            var val=snapshot.val();
            if(val!=null){

              

              this.setState({smsPrefillList:val, smsPrefillListSave: JSON.parse(JSON.stringify(val))},() =>{
                  var listPr=Object.keys(val); 
                  console.log("je vais faire "+listPr[0])
                   this.viewSMSExemple(listPr[0], 0, listPr)

                  


              })
            }
         })

    }
    else if(this.state.customerReviews!=true){



      get(child(ref(getDatabase(firebase)), "/faq")).then(snapshot => { 
        var val=snapshot.val();
         if(val!=null)  this.setState({faq:val, faqSave:JSON.parse(JSON.stringify(val)) })
      });
    }
    }



  updateHelp(rowData, position){

    if(this.state.faq[rowData]["fr"].name=="" || this.state.faq[rowData]["fr"].name==undefined || this.state.faq[rowData]["fr"].description=="" || this.state.faq[rowData]["fr"].description==undefined ) this.alert.onAlert({title:strings.thanksWriteNameDescription})
    else{
        /*je supprime le notSave*/
        var opt=this.state.faq
        delete opt[rowData].notSaved;

        var sendSave=JSON.parse(JSON.stringify(this.state.faqSave))
        sendSave[rowData]=opt[rowData];        
        if(opt[rowData].index==undefined) {opt[rowData].index=Object.keys(this.state.faqSave).length; this.setState({addHelpSelected:false}) }

        const fireInfo={} 
        fireInfo["/faq"]=sendSave
        update(ref(getDatabase(firebase)), fireInfo)

        opt[rowData]=this.state.faq[rowData]; 
        this.setState({faqSave:sendSave, faq:opt})
        this['viewHelp_' + position].close(); 

    }

  }

   removeHelp(rowData, position){
    var opt=JSON.parse(JSON.stringify(this.state.faq))
    if(this.state.faq[rowData].index==undefined){
        delete opt[rowData]; 
        this.setState({faq:opt, addOptionSelected:false}); 
    } else{
          this['viewHelp_' + position].close(); 

          var optSave=JSON.parse(JSON.stringify(this.state.faqSave))
          delete optSave[rowData];
          delete opt[rowData]; 

          var optionalOrderArray=Object.keys(optSave).sort((a,b)=>{ return optSave[a].index-optSave[b].index} )
          var i; 
          for(i=0; i<optionalOrderArray.length;i++){
            opt[optionalOrderArray[i]].index=i; 
            optSave[optionalOrderArray[i]].index=i; 
            
          }
           const fireInfo={} 
            fireInfo["/faq"]=optSave
            update(ref(getDatabase(firebase)), fireInfo)

          this.setState({faqSave:optSave, faq:opt})


    }

 }





  viewSMSExemple(type, actual, liste){
    console.log("type = "+type)
    console.log(this.state.smsPrefillList)

    var text=(this.state.smsPrefillList[type].fr.name!=undefined)?this.state.smsPrefillList[type].fr.name:""
    var date=date=new Date()
    date=((date.getDate()<10)?"0":"")+date.getDate()+"/"+(((date.getMonth()+1)<10)?"0":"")+(date.getMonth()+1)+"/"+date.getFullYear()+" - "+((date.getHours()<10)?"0":"")+date.getHours()+":"+((date.getMinutes()<10)?"0":"")+date.getMinutes()
          
    
    text = text.split('%NAME%').join(example.name)
    text = text.split('%LASTNAME%').join(example.lastName)
    text = text.split('%DATE%').join(date)

    text = text.split('%START%').join(example.adress+", "+info.companyCity)
    text = text.split('%END%').join("Gare du Centre, "+info.companyCity)

    text = text.split('%DRIVER%').join("Richard DUPOND"); 
    text = text.split('%TRACKLINK%').join("http://exempleLiensuivi.com"); 
    text = text.split('%PAYLINK%').join("http://exempleLienpaiement.com"); 
    text = text.split('%DURATION%').join("10"); 
    text = text.split('%PRICE%').join("25€"); 

    var elem=JSON.parse(JSON.stringify(this.state.smsPrefillList)); 
    elem[type].fr.nameExemple=text;  

    this.setState({smsPrefillList:elem},() =>{
      if(actual!=undefined) {
        actual+=1; 
        if(actual<liste.length) this.viewSMSExemple(liste[actual], actual, liste);
      } 

    })





  }

  updateSMS(item,i){

        if(this.state.smsPrefillList[item]!=undefined && this.state.smsPrefillList[item].fr!=undefined && this.state.smsPrefillList[item].fr.name!=undefined){
            var linkFire="/prefill/sms/"+item
            if(this.state.smsPrefillList[item].fr.name=="") {
              const fireInfo={} 
              fireInfo[linkFire]=null
              update(ref(getDatabase(firebase)), fireInfo)
            }
            else {
              const fireInfo={} 
              fireInfo[linkFire+"/fr"]={name:this.state.smsPrefillList[item].fr.name}
              update(ref(getDatabase(firebase)), fireInfo)
            }

            var elem=JSON.parse(JSON.stringify(this.state.smsPrefillList)); delete elem[item].modif;  this.setState({smsPrefillList:elem})

          }

          this['smsPr_' + i].close();  

    }




  render() {
    return (
      <StyleContext.Consumer>{style => 
      <View style={{backgroundColor:style.backgroundColor,flex:1,}}>
      {(Platform.OS=="web" && this.state.disableNavigation!=true) && <MavNavigationMinimize clickLeft={() => { this.state.params.goBack();  }} left={strings.return} title={ strings.help } />}

      <ScrollView >

      {(this.state.driver==false && this.state.customerReviews==false && this.state.smsPrefill==false && this.state.faq!=undefined) && Object.keys(this.state.faq).sort((a,b)=>{ return this.state.faq[a].index-this.state.faq[b].index} ).map((rowData,i) => (
          
          <TextPresentation helpMode={true} reduceTextSize={true} style={{marginTop:0, marginBottom:0}} text={(this.state.faq[rowData][strings.idLangue].name!=undefined)?this.state.faq[rowData][strings.idLangue].name:this.state.faq[rowData]["fr"].name} icon={(style.mode=="dark")?require('../assets/help_white.png'):require('../assets/help_black.png')} >
                <Text style={{marginTop:10,marginBottom:10,marginLeft:"10%", marginRight:"10%",color: style.textInputColor,textAlign: 'justify', fontSize:(this.state.faq[rowData][strings.idLangue].cgu==true)?10:style.textInputFontSize*0.9, marginTop: 20,color:style.textInputColor }}>{(this.state.faq[rowData][strings.idLangue].description!=undefined)?this.state.faq[rowData][strings.idLangue].description:this.state.faq[rowData]["fr"].description}</Text>
          </TextPresentation>

      ))}
      
      {(this.state.removeInProgress==false && this.state.driver==true && this.state.customerReviews==false && this.state.smsPrefill==false && Object.keys(this.state.faq).length>0) && <View>


          <MavInfoBubble type={"menu"} icon={(style.mode=="dark")?require('../assets/help_white.png'):require('../assets/help_black.png')} title={strings.help} subTitle={strings.helpMoreInfo}  style={{marginTop:10,marginBottom:20}} />
          {true && <MavInfoBubble type={"help"} videoLink={"https://www.youtube.com/watch?v=xol_ec7ytSs"} tutdoLink={"http://www.google.fr"} style={{marginTop:0,marginBottom:20}} />}

          
          {Object.keys(this.state.faq).sort((a,b)=>{ return this.state.faq[a].index-this.state.faq[b].index} ).map((rowData,i) => (

            <TextPresentation textMini={(this.state.faq[rowData].notSaved==true)?strings.notSaved:undefined} ref={viewHelp => {this['viewHelp_' + i] = viewHelp;}} style={{marginTop:0, marginBottom:0}} reduceTextSize={true} text={(this.state.faq[rowData]["fr"].name!=undefined && this.state.faq[rowData]["fr"].name!="")?this.state.faq[rowData]["fr"].name:("("+strings.noName+")" )} icon={(style.mode=="dark")?require('../assets/help_white.png'):require('../assets/help_black.png')} >

                <TextPresentation multiline={true} text={(this.state.faq[rowData][this.state.selectedElement]!=undefined && this.state.faq[rowData][this.state.selectedElement].name!=undefined)?this.state.faq[rowData][this.state.selectedElement].name:""} textExplication={strings.title}  placeholder={strings.question} chooseLanguage={this.state.selectedElement} onChangeLanguage={(value)=>{   this.setState({selectedElement:value}) }} onChangeText={(text)=>{  var opt=this.state.faq; if(this.state.faq[rowData][this.state.selectedElement]==undefined) this.state.faq[rowData][this.state.selectedElement]={}; if(this.state.faq[rowData][this.state.selectedElement].name==undefined) this.state.faq[rowData][this.state.selectedElement].name={}; opt[rowData].notSaved=true; this.state.faq[rowData][this.state.selectedElement].name=text; this.setState({faq:opt})      }}   />

                <TextPresentation multiline={true} text={(this.state.faq[rowData][this.state.selectedElement]!=undefined && this.state.faq[rowData][this.state.selectedElement].description!=undefined)?this.state.faq[rowData][this.state.selectedElement].description:""} textExplication={strings.description}  placeholder={strings.answer}  onChangeText={(text)=>{ var opt=this.state.faq; if(this.state.faq[rowData][this.state.selectedElement]==undefined) this.state.faq[rowData][this.state.selectedElement]={}; if(this.state.faq[rowData][this.state.selectedElement].name==undefined) this.state.faq[rowData][this.state.selectedElement].description={}; opt[rowData].notSaved=true; this.state.faq[rowData][this.state.selectedElement].description=text; this.setState({faq:opt})      }}   />

                <View style={{flexDirection:"row", alignItems:"center", justifyContent:"center", marginTop:10}}>
                          {this.state.faq[rowData].index!=undefined && <MavMiniButton color={"orange"}  maximize={true} icon={(style.mode=="dark")?require('../assets/back_black.png'):require('../assets/back_white.png')} text={strings.cancel} onlyButton={true}  onPress={()=>{ this['viewHelp_' + i].close(); var opt=this.state.faq; opt[rowData]=this.state.faqSave[rowData]; this.setState({faq:opt})     }} />}
                          <MavMiniButton style={{marginLeft:(this.state.faq[rowData].index!=undefined)?12:undefined, marginRight:12}} color={style.colorValidate} maximize={true} icon={(style.mode=="dark")?require('../assets/checkBasic_black.png'):require('../assets/checkBasic_white.png')} text={strings.validate} onlyButton={true}  onPress={()=>{ this.updateHelp(rowData,i);    }} />
                          <MavMiniButton color={style.colorNotification} maximize={true} icon={(style.mode=="dark")?require('../assets/close_black.png'):require('../assets/close_white.png')} text={strings.remove} onlyButton={true}  onPress={()=>{ this.removeHelp(rowData,i);  }} />

                      </View>



            </TextPresentation>

          ))}

          </View>

      }
       

      {this.state.customerReviews===true && <View>

          <TextPresentation reduceTextSizeOnOff={true} editable={false} onoff={(this.state.activateDriverNotation!=undefined && this.state.activateDriverNotation==true)} text={strings.activateDriverNotation} textMini={strings.activateDriverNotationMoreInfo}  onOnOff={()=>{ this.state.params.updateActivateDriverNotation(!this.state.activateDriverNotation) ; this.setState({activateDriverNotation:!this.state.activateDriverNotation}) }}/>

          <TextPresentation reduceTextSizeOnOff={true} editable={false} onoff={(this.state.activateCustomerNotation!=undefined && this.state.activateCustomerNotation==true)} text={strings.activateCustomerNotation} textMini={strings.activateCustomerNotationMoreInfo}  onOnOff={()=>{ this.state.params.updateActivateCustomerNotation(!this.state.activateCustomerNotation) ;this.setState({activateCustomerNotation:!this.state.activateCustomerNotation}) }}/>

          {(this.state.activateCustomerNotation==true || this.state.activateDriverNotation==true) && <TextPresentation reduceTextSizeOnOff={true} editable={false} onoff={(this.state.activateComment!=undefined && this.state.activateComment==true)} text={strings.activateComment} textMini={strings.activateCommentMoreInfo}  onOnOff={()=>{ this.state.params.updateActivateComment(!this.state.activateComment) ; this.setState({activateComment:!this.state.activateComment})}}/>}



          <TextPresentation reduceTextSizeOnOff={true} editable={false} onoff={(this.state.activateGoogleMyBusiness!=undefined && this.state.activateGoogleMyBusiness==true)} text={strings.activateGoogleMyBusiness} textMini={strings.activateGoogleMyBusinessMoreInfo}  onOnOff={()=>{ this.state.params.updateActivateGoogleMyBusiness(!this.state.activateGoogleMyBusiness) ; this.setState({activateGoogleMyBusiness:!this.state.activateGoogleMyBusiness}) }}/>


          {this.state.activateGoogleMyBusiness==true && <TextPresentation hideTopbar={true} defautVisible={true} explicationChild={strings.gestionGoogleMyBusinessLinkMoreInfo} >

                    {Object.keys(languageList).map((item,languageListI)  => (
                             <TextPresentation style={{marginTop:(languageListI==0)?20:undefined}} reduceTextSize={true} multiline={true} icon={languageList[item].flag }  text={(this.state.googleMyBusinessText[languageList[item].id]!=undefined)?this.state.googleMyBusinessText[languageList[item].id]:""} textExplication={languageList[item].name}   placeholder={"Texte"} onChangeText={(text)=>{ var el=this.state.googleMyBusinessText; el[languageList[item].id]=text;     this.setState({googleMyBusinessText:el})   }}/>
                      ))}


                    <View style={{alignItems:"center",justifyContent:"center", marginTop:40,marginBottom:10, flexDirection:"row"}}>
                        <MavButton text={strings.validate} onlyButton={true}  onPress={()=>{ this.state.params.updateGoogleMyBusinessText(this.state.googleMyBusinessText); this.setState({oldGoogleMyBusinessText:this.state.googleMyBusinessText}); this.alert.onAlert({title:strings.modifyOk})  }}/>
                    </View>


              
          </TextPresentation>}


        
      </View>}



      {this.state.smsPrefill===true && <View>

            <MavInfoBubble type={"menu"} icon={(style.mode=="dark")?require('../assets/driver_message_light.png'):require('../assets/driver_message_dark.png')} title={strings.smsPrefill} subTitle={strings.smsPrefillMoreInfo}  style={{marginTop:10,marginBottom:20}} />
            {false && <MavInfoBubble type={"help"} videoLink={"https://www.youtube.com/watch?v=cdCDHq6yxMw"} tutdoLink={"http://www.google.fr"} style={{marginTop:0,marginBottom:20}} />}

          

            {this.state.smsPrefillListBase.map((item,i) => (
             <TextPresentation reduceTextSize={true} style={{marginTop:0}} ref={smsPr => {this['smsPr_' + i] = smsPr;}} text={ (item=="validate" || item=="validateT" || item=="validateP" || item=="validatePT")?(strings.validatedRace+( (item=="validateT" || item=="validatePT")?(" "+strings.withTrackLink.toLowerCase() ):""  ) + ( (item=="validatePT" || item=="validateP")?(( (item=="validatePT")?" / ":" avec ")+strings.payLink.toLowerCase()):"" ) ): ( (item=="cancelRace")?strings.raceHasBeenCanceled :((item=="imcoming")?strings.SMSImComming :( (item=="imhere")?strings.SMSImHere:strings.confirmCancelClient) ) )  } textMini={(this.state.smsPrefillList[item]!=undefined && this.state.smsPrefillList[item].modif!=undefined)?"("+strings.notSaved+")":undefined} icon={(style.mode=="dark")?require('../assets/driver_message_light.png'):require('../assets/driver_message_dark.png')} >
                
                <Text style={{marginTop:10,marginLeft:"10%", marginRight:"10%",color: style.textInputColor,fontSize: style.textInputFontSize*0.8,textAlign: "justify",}}>{(item=="validateP")?strings.smsPrefillValidateT:( (item=="validatePT")?strings.smsPrefillValidatePT: (    (item=="validateT")?strings.smsPrefillValidateT:( (item=="imcoming")?strings.smsPrefillImcomming:strings.smsPrefillValidate)))}</Text>


                <View style={{marginTop:10,marginBottom:10, marginLeft:"10%", marginRight:"10%", minHeight:50, backgroundColor:style.backgroundColor,borderRadius: 11,borderWidth: 1, borderColor:style.backgroundColor,shadowOpacity: 0.3,shadowRadius:2,shadowOffset: {height: 0,width: 0},elevation:1 }}>

                <View style={{marginLeft:10, marginRight:10, marginTop:5, flexDirection:"row", justifyContent: 'space-between', alignItems:"center"}} >
                    <View style={{flexDirection:"row", alignItems:"center"}} >
                        <Image source={(Platform.OS=="android")?require("../assets/messageAndroid.png"):require("../assets/messageIOS.png")} style={{borderRadius: 5,borderWidth: 1,borderColor:style.backgroundColor, height:20, width:20,resizeMode:"contain"}}/>
                        <Text style={{marginLeft:5, color: style.textInputColor,fontSize: style.textInputFontSize}}>{strings.messages.toUpperCase()}</Text>
                    </View>
                    <Text style={{color: style.textInputColor,fontSize: style.textInputFontSize*0.7}}>{strings.overview}</Text>

                </View>
                <Text style={{marginLeft:10, marginTop:5, color: style.textInputColor,fontSize: style.textInputFontSize,fontWeight: 'bold',}}>{info.companyBrand}</Text>
                <Text style={{marginLeft:10,marginRight:10,  marginTop:0, marginBottom:5, color: style.textInputColor,fontSize: style.textInputFontSize}}>{(this.state.smsPrefillList[item]!=undefined && this.state.smsPrefillList[item].fr!=undefined && this.state.smsPrefillList[item].fr.nameExemple!=undefined)?this.state.smsPrefillList[item].fr.nameExemple:""}</Text>


              </View>


                <TextPresentation style={{marginTop:5}}  multiline={true} backgroundColor={style.backgroundColorContrast} editable={true} text={(this.state.smsPrefillList[item]!=undefined && this.state.smsPrefillList[item].fr!=undefined && this.state.smsPrefillList[item].fr.name!=undefined)?this.state.smsPrefillList[item].fr.name:""} textExplication={strings.text} placeholder={strings.textDefault} onChangeText={(text)=>{var elem=JSON.parse(JSON.stringify(this.state.smsPrefillList)); if(elem[item]!=undefined) elem[item].fr.name=text; else elem[item]={ fr:{name:text} } ; elem[item].modif=true;  this.setState({smsPrefillList:elem},() =>{this.viewSMSExemple(item)})     }}/>
                
                 <View style={{flexDirection:"row", alignItems:"center", justifyContent:"center", marginTop:10}}>
                          <MavMiniButton color={"orange"}  maximize={true} icon={(style.mode=="dark")?require('../assets/back_black.png'):require('../assets/back_white.png')} text={strings.cancel} onlyButton={true}  onPress={()=>{ this['smsPr_' + i].close(); var opt=this.state.smsPrefillList; opt[item]=this.state.smsPrefillListSave[item]; this.setState({faq:opt})     }} />
                          <MavMiniButton style={{marginLeft:12}} color={style.colorValidate} maximize={true} icon={(style.mode=="dark")?require('../assets/checkBasic_black.png'):require('../assets/checkBasic_white.png')} text={strings.validate} onlyButton={true}  onPress={()=>{ this.updateSMS(item,i);    }} />

                  </View>

              </TextPresentation>))}




        </View>}

      
      <View style={{width:50, height:50, }}/>    
  
      </ScrollView>

      {(this.state.addHelpSelected==false && this.state.driver==true && this.state.customerReviews==false && this.state.smsPrefill===false) && <View style={{alignItems:"center",justifyContent:"center", bottom:30, backgroundColor:style.backgroundColor, height:60}}> 
            <MavButton onlyButton={true} text={strings.add}  onPress={()=>{ var opt=JSON.parse(JSON.stringify(this.state.faq)); opt[generateUUID()]={ fr:{name:"", description:""}  }; this.setState({addHelpSelected:true, faq:opt, selectedElement:"fr",},() =>{this['viewHelp_' + (Object.keys(opt).length-1)].open(); }) }}/>
      </View>}

      {this.state.addHelpSelected==true && <View style={{width:50, height:50}} />}

      <MavAlert ref={alert => {this.alert = alert;}}/>

      </View>
      }</StyleContext.Consumer>
    );
  }
}





export function generateUUID() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
    s4() + '-' + s4() + s4() + s4();
}
